import { APIShortGameType, type PlatformType, ShortGameType, ShortGameZipType, TaskDto, TaskType } from '@/types'

export function getCurrentPlatform(userAgent: string): PlatformType {
    if (userAgent.match(/(iPhone|iPad|iPod)/)) {
        return 'ios'
    }
    if (userAgent.match(/Android/)) {
        return 'android'
    }
    return 'desktop'
}

export function shuffle<T>(array: T[]): T[] {
    const resultArray = array
    let currentIndex = array.length
    let temporaryValue
    let randomIndex
    while (currentIndex !== 0) {
        randomIndex = Math.floor(Math.random() * currentIndex)
        currentIndex -= 1
        temporaryValue = array[currentIndex]
        resultArray[currentIndex] = array[randomIndex]
        resultArray[randomIndex] = temporaryValue
    }

    return resultArray
}

export function timer(
    timeoutMs: number,
    {
        abortSignal,
    }: {
        abortSignal?: AbortSignal
    } = {},
): Promise<void> {
    return new Promise((res) => {
        const timeoutId = setTimeout(() => {
            res()
        }, timeoutMs)

        abortSignal?.addEventListener('abort', () => {
            clearTimeout(timeoutId)
        })
    })
}

export function zipAPIGame(game: APIShortGameType): ShortGameZipType {
    return [
        game.hru,
        game.title,
        game.preview,
        game.icon,
        game.video_metadata[0]?.external_url,
        game.video_metadata[0]?.playgama_id,
        game.hasInAppPurchases,
        game.rankingDebug?.data,
    ]
}

export function unzipShortGame([
    hru,
    title,
    preview,
    icon,
    videoUrl,
    videoId,
    hasInAppPurchases,
    debugInfo,
]: ShortGameZipType): ShortGameType {
    return { hru, title, preview, icon, videoUrl, videoId, hasInAppPurchases, debugInfo }
}

export function idleCallbackPromise(deadline?: number): Promise<void> {
    return new Promise((resolve) => {
        if (window.requestIdleCallback) {
            window.requestIdleCallback(
                () => {
                    resolve()
                },
                { timeout: deadline },
            )
        } else {
            setTimeout(() => {
                resolve()
            }, 1)
        }
    })
}

export function isGameTask(task: TaskDto): boolean {
    return task.type === 'PLAY_GAME'
}

export function isPlayableTask(task: { type: TaskType }): boolean {
    return task.type === 'RANDOM_GAME' || task.type === 'PLAY_GAME'
}

export function getYoutubeId(value: string | undefined) {
    let videoId = ''
    if (!value) {
        return videoId
    }

    if (value.includes('https://www.youtu.be/')) {
        videoId = value.split('https://www.youtu.be/')[1].split('?')[0]
    } else if (value.includes('https://www.youtube.com/watch?v=')) {
        videoId = value.split('https://www.youtube.com/watch?v=')[1].split('&')[0]
    } else if (value.includes('https://www.youtube.com/embed/')) {
        videoId = value.split('https://www.youtube.com/embed/')[1].split('?')[0]
    }

    return videoId
}
